/** @module app.test */

import { Assert } from 'app/test/assert';
import { ITestSession, ITestResult } from 'app/test/types';

export class TestContext implements ITestSession {

    public assertions: number = 0;
    public passed: number = 0;
    public failed: number = 0;
    public total: number = 0;
    public readonly results: ITestResult[] = [];
    public readonly output: string[] = [];

    public readonly assert: Assert = new Assert(this);

    private indentLevel: number = 0;

    constructor() { }

    public clear(): this {
        this.assertions = this.passed = this.failed = this.total = 0;
        this.indentLevel = 0;
        this.results.splice(0);
        this.output.splice(0);
        return this;
    }

    public indent(): this {
        this.indentLevel++;
        return this;
    }

    public unindent(): this {
        if(this.indentLevel > 0) {
            this.indentLevel--;
        }
        return this;
    }

    public resetOutput(): this {
        this.indentLevel = 0;
        this.output.splice(0);
        return this;
    }

    public write(message: string): this {
        const tab = '  ';
        this.output.push(`${tab.repeat(this.indentLevel)}${message}`);
        return this;
    }

}
